const ARTICLE_BODY_CONTENT_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  TABLE: 'table',
};

export default ARTICLE_BODY_CONTENT_TYPES;
